import * as React from 'react';
import MainLayout from '../Layouts/MainLayout';

const About = () => <MainLayout>About</MainLayout>;

export default About;



// WEBPACK FOOTER //
// ./src/containers/Pages/About.tsx